import React from 'react';
import styles from './BtnFileBox.module.scss';
import { Icon, Spin, Tooltip } from 'antd';
import { useSelector } from 'react-redux';
import { queryClient } from '../../../../../../../queryClient';
import { getQueryKeys } from '../../../../../queries/queryKeys';

const BtnFileBox = ({
  updateFile,
  loadingFileUpload,
  isVisibleBtn,
  onClick,
  onClickFetch,
}) => {
  const { data, file, valueForm } = useSelector(
    (state) => state.rsoImportStore
  );

  const hasData = data.length > 0;

  const valueRroDraft = queryClient.getQueryData(getQueryKeys.rsoDraft());

  const isVisivleBtnDoBack = Boolean(
    (valueForm && Object.keys(valueForm).length) || valueRroDraft === null
  );

  return (
    <div className={styles.root}>
      {isVisivleBtnDoBack && (
        <Tooltip
          title="Вернуться назад к сформированному отчету для РСО"
          placement="topLeft"
        >
          <div
            onClick={onClickFetch}
            className={styles.btnCustom}
          >
            <Icon
              type="left"
              style={{ fontSize: 18 }}
            />
          </div>
        </Tooltip>
      )}
      <div
        className={styles.containerBtn}
        style={{ width: isVisivleBtnDoBack ? 'auto' : '100%' }}
      >
        <input
          type="file"
          id="fileInput"
          onChange={updateFile}
          accept=".xlsx"
          style={{ display: 'none' }}
        />
        <label
          htmlFor="fileInput"
          className={styles.btnCustom}
        >
          {file ? `Выбран файл: ${file.name}` : 'Загрузить файл'}
        </label>
        {isVisibleBtn && !hasData && (
          <div
            className={styles.btnCustom}
            onClick={onClick}
          >
            {loadingFileUpload ? <Spin /> : 'Далее'}
          </div>
        )}
      </div>
    </div>
  );
};

export default BtnFileBox;
